module.exports = require("node:path");